export default {
	about: "درباره",
	aboutUs: "درباره‌ما",
	account: "حساب کاربری",
	active: "فعال",
	add: "ثبت",
	address: "آدرس",
	along: "همراه",
	and: "و",
	amount: "مبلغ",
	application: "اپلیکیشن",
	arithmetic: "حساب",
	around: "اطراف",
	at: "در",
	avatar: "عکس",
	back: "بازگشت",
	backHome: "بازگشت به صفحه اصلی",
	bag: "کیف",
	bakelid: "باکلید",
	bank: "بانک",
	bankAccount: "حساب بانکی",
	bankCard: "شماره کارت بانکی",
	basis: "اساس",
	bookmark: "نشان‌شده",
	boss: "رئیس",
	buy: "خرید",
	byOwner: "توسط شرکت هومان",
	call: "با ما تماس بگیرید",
	callUs: "با ما تماس بگیرید",
	cancel: "انصراف",
	category: "دسته‌بندی",
	city: "شهر",
	change: "تغییر",
	chooseLocation: "لطفا، ابتدا محل مورد نظر را انتخاب کنید.",
	cityPlaceHolder: "لطفا، ابتدا استان خود را انتخاب کنید",
	clock: "ساعت",
	code: "کد",
	comma: "،",
	conditions: "شرایط استفاده",
	confirm: "تایید",
	contactUs: "تماس‌با‌ما",
	continue: "ادامه",
	copyright: "تمامی حقوق این سایت متعلق به با کلید می‌باشد.",
	cover: "کاور",
	currency: "تومان",
	date: "تاریخ",
	delete: "حذف",
	deleteConfirm: "از حذف این آیتم اطمینان دارید؟",
	deposit: "واریز",
	description: "توضیحات",
	direct: "مستقیم",
	discount: "تخفیف",
	discountPercent: "درصد تخفیف",
	download: "دانلود",
	edit: "ویرایش",
	email: "برای ما ایمیل بفرستید",
	enter: "ورود",
	faq: "سوالات متداول",
	fax: "فکس",
	faxUs: "شماره فکس",
	firstName: "نام",
	forgotPass: "بازیابی رمز عبور",
	from: "از",
	googlePlay: "گوگل پلی",
	ha: "‌ها",
	holding: "موجودی",
	home: "خانه",
	i: "من",
	iAgree: "را میپذیرم",
	image: "عکس",
	increase: "افزایش",
	instagram: "اینستاگرام",
	info: "اطلاعات",
	job: "شغل",
	jobs: "مشاغل",
	lastName: "نام خانوادگی",
	loadingText: "باکلید، بانک مشاغل ایران",
	location: "موقعیت",
	loginText: "لطفا کلمه عبور خود را وارد کنید",
	logout: "خروج",
	manage: "مدیریت",
	million: "میلیون",
	mobile: "موبایل",
	money: "پول",
	name: "نام",
	needSupport: "اگر نیاز به پشتیبانی داری تماس بگیر",
	new: "جدید",
	notifications: "اعلانات",
	notPublished: "نمایش داده نشود",
	number: "شماره",
	organization: "مجموعه",
	on: "بر",
	page: "پیج",
	password: "رمز عبور",
	pay: "پرداخت",
	panelBk: "پنل کاربری باکلید",
	pendingAdmin: "در انتظار تایید پشتیبانی",
	percent: "درصد",
	phone: "تلفن",
	precise: "دقیق",
	previous: "قبل",
	privacyPolicy: "از خدمات و حریم خصوصی",
	profile: "پروفایل",
	province: "استان",
	publish: "نمایش",
	published: "نمایش داده شود",
	receive: "دریافت",
	register: "ثبت نام",
	reject: "رد",
	resend: "ارسال مجدد",
	results: "نتایج",
	rial: "ریال",
	saveCondition: "برای نشان کردن شغل ابتدا باید وارد شوید",
	score: "امتیاز",
	search: "جستجو",
	set: "تایین",
	services: "خدمات",
	sort: "چینش",
	special: "ویژه",
	status: "وضعیت",
	statusText: "جهت ورود و یا عضویت شماره موبایل خود را وارد کنید",
	subject: "موضوع",
	submit: "ارسال",
	subscription: "اشتراک",
	support: "پشتیبانی",
	supportBk: "تماس و پشتیبانی با کلید",
	yourSubject: "موضوع پیام خود را وارد کنید",
	supportText: "کارشناسان ما منتظر صدای گرمتان هستند",
	supportWays:
		"میتونی با تیم با کلید از طریق راه های زیر با ما ارتباط برقرار کنی",
	terms: "قوانین و مقررات",
	ticket: "برای ما پیام بفرستید",
	to: "به",
	toBe: "شده",
	toBeNot: "نشده",
	toman: "تومان",
	transaction: "تراکنش",
	tracking: "پیگیری",
	type: "نوع",
	unauthorized: "متأسفیم، شما به این صفحه دسترسی ندارید.",
	upload: "بارگذاری",
	verifyText: "کد 5 رقمی به شماره شما پیامک شد، لطفا آنرا وارد نمایید",
	wallet: "کیف پول",
	walletInput: "مبلغ دلخواه خود راوارد کنید",
	webDesign: "طراحی سایت",
	website: "وب‌سایت",
	welcome: "خوش آمدید",
	working: "کاری",
	y: "ی",
	your: "شما",

	manageModal: {
		addJob: "توضیحات ثبت شغل",
		bannerAd: "تبلیغات در بنر های صفحات",
		bannerAdDesc:
			"یک امکان ویژه برای دریافت بازخود بهتر، استفاده از امکان بنرهای تبلیغاتی می باشد.  این کار به بیشتر دیده شدن شغل شما کمک می کند. برای اطلاعات بیشتر میتوانید با ما تماس بگیرید.",
		changePublish: "تغییر وضعیت انتشار",
		publishTitle: "از تغییر وضعیت این آیتم اطمینان دارید؟",
		jobSub: "اشتراک ثبت شغل",
		ladderAd: "تبلیغات نردبانی",
		seeDetail: "مشاهده صفحه مشخصات شغل",
		specialAd: "تبلیغات مشاغل ویژه",
		specialAdDesc:
			"یک امکان ویژه برای دریافت بازخود بهتر، استفاده از  امکان مشاغل ویژه صفحه اصلی می‌باشد.  این کار به بیشتر دیده شدن شغل شما کمک می کند. برای اطلاعات بیشتر میتوانید با ما تماس بگیرید.",
	},

	uploadErros: {
		size: "حجم فایل باید کمتر از 10 مگ باشد",
		extension: "فرمت تصویر معتبر نمی‌باشد",
	},
	lorem: {
		word: "لورم",
		sentence: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ",
		paragraphSm:
			"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد",
		paragraphLg:
			"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
	},
};
